import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import IDevelopmentsResolver from "@models/IDevelopmentsResolver.model";
import { DevelopmentService } from "@services/development.service";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DevelopmentsResolver implements Resolve<IDevelopmentsResolver> {
  constructor(public router: Router, public developmentService: DevelopmentService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<IDevelopmentsResolver> | Promise<IDevelopmentsResolver> {
    const development = this.developmentService
      .getItems()
      .filter((item) => item.id == route.params["itemId"])[0];

    return of({ development });
  }
}
